import React from 'react';
import { motion } from 'framer-motion';
const benefits = [{
  emoji: '📖',
  title: 'Capacitaciones al Día, Todo el Año',
  desc: 'Cada semana tiene su material completo, su evaluación lista y su registro firmado. Sin preparación de último momento ni papeles perdidos.'
}, {
  emoji: '📈',
  title: 'Control Profesional Real',
  desc: 'Sabés exactamente qué capacitaste en cada empresa, qué está pendiente y qué vence el mes que viene. Sin sorpresas de la SRT ni de la ART.'
}, {
  emoji: '🕊️',
  title: 'Tranquilidad Mental',
  desc: 'Se terminó la sensación de que "algo siempre falta". Tu año de capacitaciones tiene sistema y vos podés enfocarte en lo que realmente importa: atender más empresas y crecer.'
}, {
  emoji: '❤️',
  title: 'Profesionalismo Visible',
  desc: 'Cada capacitación tiene su presentación. Cada asistente tiene su registro firmado. Cada tema tiene su evaluación. Así se construye una carrera sólida y sin exposición legal.'
}];
export function BenefitsSection() {
  return <section className="py-12 md:py-16 bg-transparent" data-id="element-2">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-3">
        <div className="text-center mb-12" data-id="element-4">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-[#2f3a2c] mb-4" data-id="element-5">
            LO QUE VA A CAMBIAR
          </h2>
          <p className="text-lg text-slate-600" data-id="element-6">
            Lo que va a cambiar en tu gestión profesional desde la primera
            semana
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-8" data-id="element-7">
          {benefits.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white border border-amber-100 p-8 rounded-3xl shadow-sm" data-id="element-8">
              <div className="text-4xl mb-4" data-id="element-9">{b.emoji}</div>
              <h3 className="text-xl font-bold text-[#2f3a2c] mb-3" data-id="element-10">
                {b.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-11">{b.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}